module.exports = __webpack_public_path__ + "img/logo.3e8c9471.png";